"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventActions = void 0;
var EventActions;
(function (EventActions) {
    EventActions["ACCEPTED"] = "accepted";
    EventActions["EXPIRED"] = "expired";
    EventActions["REFUSED"] = "refused";
    EventActions["ACCEPTED_FOR"] = "accepted for";
    EventActions["EXPIRED_EVERYONE_REFUSED"] = "expired - everyone refused";
    EventActions["ORDER_CANCELED"] = "order canceled";
    EventActions["NO_TRADER_ACCEPTED"] = "no trader accepted";
})(EventActions = exports.EventActions || (exports.EventActions = {}));
//# sourceMappingURL=events.js.map